import Link from 'next/link'
import { RelatedProduct } from '@lib/related-product'
import Button from '@comp/ui/button'

/**
 * Inline CTA at the end of an article pointing to the product the post is
 * actually about: the internal link from content to product pages.
 */
export default function ProductCta({ product }: { product: RelatedProduct }) {
  return (
    <aside className="mt-16 rounded-3xl border border-line-subtle bg-surface-subtle p-8 lg:p-10">
      <div className="text-eyebrow font-semibold uppercase tracking-[0.12em] text-brand-700">
        {product.eyebrow}
      </div>
      <h2 className="mt-3 text-display-sm font-medium text-ink-primary">
        Put this into practice with{' '}
        <Link
          href={product.href}
          className="text-brand-700 underline-offset-4 hover:underline"
        >
          {product.name}
        </Link>
        .
      </h2>
      <p className="mt-3 max-w-2xl text-body-md text-ink-secondary">
        {product.pitch}
      </p>
      <div className="mt-6 flex flex-wrap items-center gap-3">
        <Button href={product.href} variant="primary" size="md">
          Explore {product.name}
        </Button>
        <Button href="/try/now" variant="outline" size="md">
          Start free trial
        </Button>
      </div>
    </aside>
  )
}
